module.exports = __webpack_public_path__ + "static/media/F4FF89B7-5615-4A22-B613-04E48FBB89BF - Copy.aa0e6e54.JPG";